
export const Landingdata = {
    name:"Mir Junaid Rasool",
    about: "Professor Educator Developer Trainer Researcher",
    info:"Assistant Professor with extensive experience in teaching and training students across various computer science domains. Expertise includes Web Development, Cloud Computing, Machine Learning, Data Management, Programming, and Lecturing. EPAM Certified Front-End Trainer and PhD candidate, dedicated to continuous learning and advancing both individual expertise and organizational research development.",
    address:"Anantnag, India",
    linkedin:"https://www.linkedin.com/in/mirjunaidrasool/",
    github:"https://github.com/Mir-Junaid-Rasool",
    mail:"mirjunaidmir@gmail.com",
    insta:"https://www.instagram.com/mjmjunaid/",
    youtube:"https://www.youtube.com/A2ZITServices",
    phone:8825021631, 
    DOB:'10/March/1996',
    currentwork:'Assistant Professor at Jain Deemed to be university',
    highestdegree:'M.tech (Computer Science & Engineering)',
    Portfoliolink:'https://mirjunaid.netlify.app/'   
}
